import { FJDecoderManager } from '@fj/codec';
import FJFileHandleUtil from '../../util/FJFileHandleUtil.js';
import FJUtil from '../../util/FJUtil.js';

// 口播的原始资源
class FJTextBasedEditingMedia {
    constructor() {
        this._blob = null;
        this._url = '';
        this._type = '';
        this._mimeType = '';
        this._duration = 0;
        this._id = null;
        this._audioResource = null; // 音频资源
    }

    //#region getter
    get blob() {
        return this._blob;
    }

    get url() {
        return this._url;
    }

    get type() {
        return this._type;
    }

    get mimeType() {
        return this._mimeType;
    }

    get duration() {
        return this._duration;
    }

    get mediaId() {
        return this._id;
    }

    get audioResource() {
        return this._audioResource;
    }
    //#endregion

    setMediaSource = blob => {
        this._blob = blob;
    };

    loadMediaSource = () => {
        return new Promise((resolve, reject) => {
            (async () => {
                if (!this._blob) reject(new Error('no blob'));
                const fileType = this._blob.type || this._blob.mimeType;
                if (!fileType) reject(new Error('unsupported format'));
                const isVideo = fileType.startsWith('video');
                const isAudio = fileType.startsWith('audio');
                if (!isVideo && !isAudio) reject(new Error('unsupported format'));

                // 大于2g
                if (this._blob.size > 2 * 1024 * 1024 * 1024) {
                    reject(new Error('file too large'));
                    return;
                }

                const url = URL.createObjectURL(this._blob);
                // const url = await FJFileHandleUtil.loadFileToUrl(this._blob).catch(() => {
                //     reject(new Error('load media source failed'));
                // });
                if (!url) {
                    reject(new Error('load media source failed'));
                    return;
                }
                const duration = await this._getMediaDuration(url, isVideo).catch(e => {
                    reject(new Error('load media source failed'));
                });
                // 小于1s或大于40分钟
                if (!duration || duration < 1 || duration >= 60 * 41) {
                    reject(new Error('duration error'));
                    return;
                }

                if (isVideo) {
                    const audioData = await this._getAudioBufferAsync({
                        endTime: duration,
                    }).catch(e => {
                        console.log(e);
                        reject(new Error('decode audio error'));
                    });

                    if (!audioData || audioData?.length === 0) {
                        reject(new Error('decode audio error'));
                        return;
                    }

                    const audioBlob = await FJUtil.encodeMp3(audioData, 2).catch(e => {
                        console.log(e);
                        reject(new Error('decode audio error'));
                    });

                    // const audioBlob = await this._compressAudioToMP3(audioData).catch(e => {
                    //     console.log(e);
                    //     reject(new Error('decode audio error'));
                    // });

                    if (!audioBlob) {
                        reject(new Error('decode audio error'));
                        return;
                    }
                    const mimeType = 'audio/mpeg';
                    this._audioResource = new Blob(audioBlob, { type: mimeType });
                    // Download(blob, 'test.mp3', 'audio/mp3');

                    // console.log('音频文件大小', this._audioResource.size / 1000 / 1000, 'm');
                } else {
                    this._audioResource = this._blob;
                }

                this._duration = duration;
                this._url = url;
                this._type = isVideo ? 'video' : 'audio';
                this._mimeType = this._blob.type;
                this._id = await FJFileHandleUtil.hashEncode(this._blob);
                resolve();
            })();
        });
    };

    release = () => {
        URL.revokeObjectURL(this._url);
        this._blob = null;
        this._audioResource = null;
        this._url = '';
        this._type = '';
        this._mimeType = '';
        this._duration = 0;
        this._id = null;
    };

    async _getAudioBufferAsync(options = {}) {
        if (!this._blob) throw new Error('no blob');
        const { endTime = 0 } = options;
        return await FJDecoderManager.decodeAudioOverall(this._blob, {
            start: 0,
            end: endTime ? endTime : this._duration,
            samplerate: FJUtil.getAudioSampleRate(),
            mode: 'FFMPEG',
            speed: 1,
            fileType: 'video',
            ignoreNoValidDuration: true,
        });
    }

    _getMediaDuration = (url, isVideo = true) => {
        return new Promise((resolve, reject) => {
            // 根据Blob的MIME类型创建对应的媒体元素
            const mediaElement = isVideo ? document.createElement('video') : document.createElement('audio');

            mediaElement.addEventListener('seeked', () => {
                resolve(mediaElement.duration);
            });

            // 监听元数据加载完成事件
            mediaElement.addEventListener('loadedmetadata', () => {
                if (mediaElement.duration === Infinity) {
                    mediaElement.currentTime = 10000;
                } else {
                    // 获取时长并解析Promise
                    resolve(mediaElement.duration);
                }
            });

            // 监听错误事件
            mediaElement.addEventListener('error', reject);

            // 设置媒体元素的src为Blob的URL
            mediaElement.src = url;
        });
    };
}

export default FJTextBasedEditingMedia;
